<template>
  <div>
    <table cellspacing="0" border="0" ref="box">
    	<colgroup width="99"></colgroup>
    	<colgroup width="147"></colgroup>
    	<colgroup width="145"></colgroup>
    	<colgroup width="118"></colgroup>
    	<colgroup width="124"></colgroup>
    	<colgroup width="139"></colgroup>
    	<colgroup width="141"></colgroup>
    	<tr>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=7 height="36" align="center" valign=middle><b><font face="DejaVu Sans" size=4 color="#000000">眼健康检查评估报告</font></b></td>
    		</tr>
    	<tr>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" height="24" align="left" valign=middle><b><font face="DejaVu Sans" color="#000000">姓名：</font></b></td>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" align="left" valign=middle>
          <input type="text" v-model="myForm.name"/>
        </td>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" align="left" valign=middle><b><font face="DejaVu Sans" color="#000000">年龄：</font></b></td>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" align="left" valign=middle><input type="number" @input="handleInput" v-model="myForm.age"/></td>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" align="left" valign=middle><b><font face="DejaVu Sans" size=3 color="#000000">检查日期：</font></b></td>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=2 align="center" valign=middle><input type="date" v-model="myForm.jianchariqi"/></td>
    		</tr>
    	<tr>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=7 height="24" align="center" valign=middle><b><font face="DejaVu Sans" size=3 color="#000000">最新检查数据</font></b></td>
    		</tr>
    	<tr>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=2 height="24" align="center" valign=middle><font size=3 color="#000000"><br></font></td>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=2 align="center" valign=middle><font face="DejaVu Sans" size=3 color="#000000">右眼OD</font></td>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=2 align="center" valign=middle><font face="DejaVu Sans" size=3 color="#000000">左眼OS</font></td>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" align="center" valign=middle><font face="DejaVu Sans" size=3 color="#000000">双眼OU</font></td>
    	</tr>
    	<tr>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=2 height="24" align="center" valign=middle><font face="DejaVu Sans" size=3 color="#000000">裸眼视力</font></td>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" align="center" valign=middle><input type="number" @input="handleInput" v-model="myForm.luoyanod"/></td>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" align="center" valign=middle bgcolor="#C0C0C0"><font face="DejaVu Sans">{{myForm.luoyanodname}}</font></td>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" align="center" valign=middle><input type="number" @input="handleInput" v-model="myForm.luoyanos"/></td>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" align="center" valign=middle bgcolor="#C0C0C0"><font face="DejaVu Sans">{{myForm.luoyanosname}}</font></td>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" align="right" valign=middle><input type="number" v-model="myForm.luoyanou"/></td>
    	</tr>
    	<tr>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=2 height="24" align="center" valign=middle><font face="DejaVu Sans" size=3 color="#000000">等效球镜</font></td>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" align="center" valign=middle><input type="number" @input="handleInput" v-model="myForm.dengxiaoqiujingod"/></td>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" align="center" valign=middle bgcolor="#C0C0C0"><font face="DejaVu Sans">{{myForm.dengxiaoqiujingodname}}</font></td>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" align="center" valign=middle><input type="number" @input="handleInput" v-model="myForm.dengxiaoqiujingos"/></td>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" align="center" valign=middle bgcolor="#C0C0C0"><font face="DejaVu Sans">{{myForm.dengxiaoqiujingosname}}</font></td>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" align="left" valign=middle><input type="number" v-model="myForm.dengxiaoqiujingou"/></td>
    	</tr>
    	<tr>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=2 height="24" align="center" valign=middle><font face="DejaVu Sans" size=3 color="#000000">单眼1.0矫正屈光度</font></td>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=2 align="center" valign=middle><input v-model="myForm.danyanjiaozhengod"/></td>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=2 align="center" valign=middle><input v-model="myForm.danyanjiaozhengos"/></td>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" align="left" valign=middle><input v-model="myForm.danyanjiaozhengou"/></td>
    	</tr>
    	<tr>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=2 height="24" align="center" valign=middle><font face="DejaVu Sans" size=3 color="#000000">最佳矫正屈光度</font></td>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=2 align="center" valign=middle><input v-model="myForm.zuijiajiaozhengod"/></td>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=2 align="center" valign=middle><input v-model="myForm.zuijiajiaozhengos"/></td>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" align="left" valign=middle><input v-model="myForm.zuijiajiaozhengou"/></td>
    	</tr>
    	<tr>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=2 height="24" align="center" valign=middle><font face="DejaVu Sans" size=3 color="#000000">最佳矫正视力</font></td>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" align="center" valign=middle><input type="number" @input="handleInput" v-model="myForm.zuijiajzshiliod"/></td>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" align="center" valign=middle bgcolor="#C0C0C0">{{myForm.zuijiajzshiliodname}}</td>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" align="center" valign=middle><input type="number" @input="handleInput" v-model="myForm.zuijiajzshilios"/></td>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" align="center" valign=middle bgcolor="#C0C0C0">{{myForm.zuijiajzshiliosname}}</td>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" align="left" valign=middle><input type="number" v-model="myForm.zuijiajzshiliou"/></td>
    	</tr>
    	<tr>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=2 height="24" align="center" valign=middle><font face="DejaVu Sans" size=3 color="#000000">眼轴AL</font></td>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=2 align="center" valign=middle><input type="number" @input="handleInput" v-model="myForm.yanzhoualod"/></td>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=2 align="center" valign=middle><input type="number" @input="handleInput" v-model="myForm.yanzhoualos"/></td>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" align="left" valign=middle><input type="number" v-model="myForm.yanzhoualou"/></td>
    	</tr>
    	<tr>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=2 height="24" align="center" valign=middle><font face="DejaVu Sans" size=3 color="#000000">角膜曲率</font></td>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=2 align="center" valign=middle><input v-model="myForm.jiaomoqulvod"/></td>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=2 align="center" valign=middle><input v-model="myForm.jiaomoqulvos"/></td>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" align="left" valign=middle><input v-model="myForm.jiaomoqulvou"/></td>
    	</tr>

    	<tr>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=7 height="400" align="center" valign=middle>
          <ve-line
          v-if="lineDataLoaded"
          :data="shiLiQuXianData"
          :settings="shiLiQuXianSettings"
          :colors="shiLiQuXianColors">
          </ve-line>
        </td>
    	</tr>
    	<tr>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=7 height="400" align="center" valign=middle>
          <ve-line
          v-if="lineDataLoaded"
          :data="YanZhouFaYuQuXianData"
          :colors="YanZhouFaYuQuXianColors">
          </ve-line>
        </td>
    	</tr>
    	<tr>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=7 height="400" align="center" valign=middle>
          <ve-line
          v-if="lineDataLoaded"
          :data="YanQuGuangFaYuQuXianData"
          :colors="YanQuGuangFaYuQuXianColors">
          </ve-line>
        </td>
    	</tr>

    	<tr>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=7 height="27" align="center" valign=middle><b><font face="DejaVu Sans" size=3 color="#000000">评估及建议</font></b></td>
    	</tr>
    	<tr>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=3 height="27" align="left" valign=middle><font face="DejaVu Sans" size=2 color="#000000">根据已提供的检查数据，初步评估为：</font></td>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=4 align="center" valign=middle>
          <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="myForm.chubupinggu"></el-input>
        </td>
    	</tr>
    	<tr>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=3 height="85" align="left" valign=middle><font face="DejaVu Sans" size=2 color="#000000">建议采用以下方式进行干预：<br>（参考：1、放松训练；2、调节训练；3、视功能训练；4进一步检查，确定是否为弱视、斜视或其它视功能异常）</font></td>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=4 align="center" valign=top>
          <el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="myForm.ganyufangshi"></el-input>
        </td>
    	</tr>
    	<tr>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=3 height="24" align="left" valign=top><font face="DejaVu Sans" size=2 color="#000000">建议每个月复查一次，下次复查时间：</font></td>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=4 align="center" valign=top><input type="date" v-model="myForm.fuchashijian"/></td>
    	</tr>
    	<tr>
    		<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000; border-right: 1px solid #000000" colspan=7 height="40" align="left" valign=middle bgcolor="#C0C0C0"><font face="DejaVu Sans" size=3 color="#000000">本次评估仅针对已提供的检测数据进行评估，如果对于干预方案不了解或干预过程中出现眼部不适，请及时联系专家老师。</font></td>
    	</tr>
    </table>
    <div class="addbutton">
      <el-button type="primary" v-if="processingMode == 1" @click="clickAdd">添加</el-button>
      <el-button type="primary" v-if="processingMode == 3" @click="clickModify">修改</el-button>
      <el-button type="info" @click="clickBack">返回</el-button>
      <el-button type="primary" @click="clicksavepic">下载</el-button>
    </div>
  </div>
</template>

<script>
import html2canvas from 'html2canvas'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data() {
    this.shiLiQuXianSettings = {
      min: [4.0],
    };
    return {
      Name: "眼健康评估曲线图",
      //1添加;2查看;3修改
      processingMode: 1,
      myFormBack: null,
      myForm:{
        id: "0",
        glassuserid: "0",
        name: "",
        age: "",
        jianchariqi: "",
        luoyanod: "",
        luoyanos: "",
        luoyanou: "",
        luoyanodname: "",
        luoyanosname: "",
        dengxiaoqiujingod: "",
        dengxiaoqiujingos: "",
        dengxiaoqiujingou: "",
        dengxiaoqiujingodname: "",
        dengxiaoqiujingosname: "",
        danyanjiaozhengod: "",
        danyanjiaozhengos: "",
        danyanjiaozhengou: "",
        zuijiajiaozhengod: "",
        zuijiajiaozhengos: "",
        zuijiajiaozhengou: "",
        zuijiajzshiliod: "",
        zuijiajzshilios: "",
        zuijiajzshiliou: "",
        zuijiajzshiliodname: "",
        zuijiajzshiliosname: "",
        yanzhoualod: "",
        yanzhoualos: "",
        yanzhoualou: "",
        jiaomoqulvod: "",
        jiaomoqulvos: "",
        jiaomoqulvou: "",
        chubupinggu: "",
        ganyufangshi: "",
        fuchashijian: ""
      },
      lineDataLoaded: false,
      //裸眼视力曲线
      shiLiQuXianData: {
        columns: ['age', '正常裸眼最低值', '正常裸眼最高值', '裸眼视力OD', '裸眼视力OS'],
        rows: []
      },
      shiLiQuXianColors: ['#aaff7f','#55aaff','#ff0000','#ff0000'],
      //眼轴发育曲线
      YanZhouFaYuQuXianData: {
        columns: ['age', '眼轴标准均长', '眼轴上限均值', '眼轴年增长均值' ,'眼轴OD', '眼轴OS'],
        rows: []
      },
      YanZhouFaYuQuXianColors: ['#0055ff','#5b9bd5','#a5a5a5','#ff0000','#ff0000'],
      //眼屈光发育曲线图
      YanQuGuangFaYuQuXianData: {
        columns: ['age', '生理性远视储备', '等效球镜OD', '等效球镜OS'],
        rows: []
      },
      YanQuGuangFaYuQuXianColors: ['#5b9bd5','#ff0000','#ff0000'],
      effectiveDurationData: {
        columns: ['日期', '占比'],
        rows: [
          { 日期: '7天提升2行', 占比: 0.95 },
          { 日期: '30天提升3-4行', 占比: 0.91 },
          { 日期: '60天提升3-4行', 占比: 0.9 },
          { 日期: '90天提升3-4行', 占比: 0.87 },
          { 日期: '120天提升3-4行', 占比: 0.85 },
          { 日期: '365天提升3-4行', 占比: 0.8 }
        ]
      },
      trainingColors: ['#4ad2ff'],
    };
  },
  mounted () {
  },
  methods: {
    clickBack () {
      this.$emit('triggerFunc', '')
    },
    clicksavepic () {
      var that = this
      html2canvas(that.$refs.box, {
        useCORS: true,
        allowTaint: false
      }).then(function (canvas) {
        var a = document.createElement('a')
        a.href = canvas.toDataURL('image/jpeg')
        a.download = that.Name
        a.click()
        a.remove()
      })
    },
    initData (glassuserid) {
      this.myForm.glassuserid = glassuserid
      this.myFormBack = Vue.prototype.CloneObj(this.myForm)
    },
    showLine(){
      this.lineDataLoaded = true;
    },
    editMode(row){
      this.processingMode = 3
      this.myForm.id = row.Id
      this.myForm.name  = row.Name
      this.myForm.age  = row.Age
      this.myForm.jianchariqi  = row.Jianchariqi
      this.myForm.luoyanod  = row.Luoyanod
      this.myForm.luoyanos  = row.Luoyanos
      this.myForm.luoyanou  = row.Luoyanou
      this.myForm.luoyanodname  = row.Luoyanodname
      this.myForm.luoyanosname  = row.Luoyanosname
      this.myForm.dengxiaoqiujingod  = row.Dengxiaoqiujingod
      this.myForm.dengxiaoqiujingos  = row.Dengxiaoqiujingos
      this.myForm.dengxiaoqiujingou  = row.Dengxiaoqiujingou
      this.myForm.dengxiaoqiujingodname  = row.Dengxiaoqiujingodname
      this.myForm.dengxiaoqiujingosname  = row.Dengxiaoqiujingosname
      this.myForm.danyanjiaozhengod  = row.Danyanjiaozhengod
      this.myForm.danyanjiaozhengos  = row.Danyanjiaozhengos
      this.myForm.danyanjiaozhengou  = row.Danyanjiaozhengou
      this.myForm.zuijiajiaozhengod  = row.Zuijiajiaozhengod
      this.myForm.zuijiajiaozhengos  = row.Zuijiajiaozhengos
      this.myForm.zuijiajiaozhengou  = row.Zuijiajiaozhengou
      this.myForm.zuijiajzshiliod  = row.Zuijiajzshiliod
      this.myForm.zuijiajzshilios  = row.Zuijiajzshilios
      this.myForm.zuijiajzshiliou  = row.Zuijiajzshiliou
      this.myForm.zuijiajzshiliodname  = row.Zuijiajzshiliodname
      this.myForm.zuijiajzshiliosname  = row.Zuijiajzshiliosname
      this.myForm.yanzhoualod  = row.Yanzhoualod
      this.myForm.yanzhoualos  = row.Yanzhoualos
      this.myForm.yanzhoualou  = row.Yanzhoualou
      this.myForm.jiaomoqulvod  = row.Jiaomoqulvod
      this.myForm.jiaomoqulvos  = row.Jiaomoqulvos
      this.myForm.jiaomoqulvou  = row.Jiaomoqulvou
      this.myForm.chubupinggu  = row.Chubupinggu
      this.myForm.ganyufangshi  = row.Ganyufangshi
      this.myForm.fuchashijian  = row.Fuchashijian

      this.showLine();
      this.handleInput();
    },
    clickAdd () {
      this.$confirm('您确定需要添加吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiAddErp7ShiGuangYanJianKangQuXian()
      })
    },
    clickModify () {
      this.apiEditErp7ShiGuangYanJianKangQuXian()
    },
    handleInput(){
      var age = Number(this.myForm.age);
      var luoyanod = Number(this.myForm.luoyanod);
      var luoyanos = Number(this.myForm.luoyanos);
      var dengxiaoqiujingod = Number(this.myForm.dengxiaoqiujingod);
      var dengxiaoqiujingos = Number(this.myForm.dengxiaoqiujingos);
      var zuijiajzshiliod = Number(this.myForm.zuijiajzshiliod);
      var zuijiajzshilios = Number(this.myForm.zuijiajzshilios);
      var yanzhoualod = Number(this.myForm.yanzhoualod);
      var yanzhoualos = Number(this.myForm.yanzhoualos);
      this.myForm.luoyanodname = this.handleInputLuoYanShiLi(age,luoyanod);
      this.myForm.luoyanosname = this.handleInputLuoYanShiLi(age,luoyanos);
      this.myForm.dengxiaoqiujingodname = this.handleInputDengXiaoQiuJing(age,dengxiaoqiujingod);
      this.myForm.dengxiaoqiujingosname = this.handleInputDengXiaoQiuJing(age,dengxiaoqiujingos);
      this.myForm.zuijiajzshiliodname = this.handleInputZuiJiaJzShiLi(age,zuijiajzshiliod);
      this.myForm.zuijiajzshiliosname = this.handleInputZuiJiaJzShiLi(age,zuijiajzshilios);
      this.handleShiLiQuXianData(age,luoyanod,luoyanos);
      this.handleYanZhouFaYuQuXianData(age,yanzhoualod,yanzhoualos)
      this.handleYanQuGuangFaYuQuXianData(age,dengxiaoqiujingod,dengxiaoqiujingos)
    },
    handleInputLuoYanShiLi(age,luoyan){
      var min = 0;
      var max = 0;
      if(age<=4){
        min = 4.8;
        max = 4.9;
      } else {
        min = 5.0;
        max = 9999.0;
      }
      if(luoyan>=min && luoyan <=max){
        return '正常'
      } else {
        return '异常'
      }
    },
    handleInputDengXiaoQiuJing(age,dengxiaoqiujing){
      var rv = '';
      var yuanshichubei = 0;
      if(age <= 4){
        yuanshichubei = 2.2;
      }
      if(age == 5){
        yuanshichubei = 2.1;
      }
      if(age == 6){
        yuanshichubei = 1.75;
      }
      if(age == 7){
        yuanshichubei = 2.0;
      }
      if(age == 8){
        yuanshichubei = 1.5;
      }
      if(age == 9){
        yuanshichubei = 1.25;
      }
      if(age == 10){
        yuanshichubei = 1.0;
      }
      if(age == 11){
        yuanshichubei = 0.75;
      }
      if(age == 12){
        yuanshichubei = 0.5;
      }
      if(age == 13){
        yuanshichubei = 0;
      }
      if(age <= 13){
        if(dengxiaoqiujing<yuanshichubei && dengxiaoqiujing > 0){
          rv += '远视储备不足;'
        }
      }
      if(dengxiaoqiujing>=-3.00 && dengxiaoqiujing <=0){
        rv += '轻度近视;'
      }
      if(dengxiaoqiujing>=-6.00 && dengxiaoqiujing <=-3.25){
        rv += '中度近视;'
      }
      if(dengxiaoqiujing<-6.00){
        rv += '高度近视;'
      }
      var dengxiaoqiujingBuf = dengxiaoqiujing - yuanshichubei;
      if(dengxiaoqiujingBuf>= 0.75 && dengxiaoqiujingBuf <= 3.0){
        rv += '轻度远视;'
      }
      if(dengxiaoqiujingBuf>= 3.25 && dengxiaoqiujingBuf <= 6.0){
        rv += '中度远视;'
      }
      if(dengxiaoqiujingBuf>6.00){
        rv += '高度远视;'
      }
      return rv;
    },
    handleInputZuiJiaJzShiLi(age,zuijiajzshili){
      var zuijiajzshiliBase = 0;
      if(age <= 4){
        zuijiajzshiliBase = 4.7;
      }
      if(age == 5){
        zuijiajzshiliBase = 4.8;
      }
      if(age == 6){
        zuijiajzshiliBase = 4.9;
      }
      if(age >= 7){
        zuijiajzshiliBase = 5.0;
      }

      if(zuijiajzshili >= zuijiajzshiliBase){
        return '正常';
      } else {
        return '弱视';
      }
    },
    handleShiLiQuXianData(age,od,os){
      var list = [];
      list.push({ age: '4岁', 正常裸眼最低值: 4.8, 正常裸眼最高值: 4.9, 裸眼视力OD: null, 裸眼视力OS: null});
      list.push({ age: '5岁', 正常裸眼最低值: 5.0, 正常裸眼最高值: 5.0, 裸眼视力OD: null, 裸眼视力OS: null});
      list.push({ age: '6岁', 正常裸眼最低值: 5.0, 正常裸眼最高值: 5.0, 裸眼视力OD: null, 裸眼视力OS: null});
      list.push({ age: '7岁', 正常裸眼最低值: 5.0, 正常裸眼最高值: 5.0, 裸眼视力OD: null, 裸眼视力OS: null});
      list.push({ age: '8岁', 正常裸眼最低值: 5.0, 正常裸眼最高值: 5.0, 裸眼视力OD: null, 裸眼视力OS: null});
      list.push({ age: '9岁', 正常裸眼最低值: 5.0, 正常裸眼最高值: 5.0, 裸眼视力OD: null, 裸眼视力OS: null});
      list.push({ age: '10岁', 正常裸眼最低值: 5.0, 正常裸眼最高值: 5.0, 裸眼视力OD: null, 裸眼视力OS: null});
      list.push({ age: '11岁', 正常裸眼最低值: 5.0, 正常裸眼最高值: 5.0, 裸眼视力OD: null, 裸眼视力OS: null});
      list.push({ age: '12岁', 正常裸眼最低值: 5.0, 正常裸眼最高值: 5.0, 裸眼视力OD: null, 裸眼视力OS: null});
      list.push({ age: '13岁', 正常裸眼最低值: 5.0, 正常裸眼最高值: 5.0, 裸眼视力OD: null, 裸眼视力OS: null});
      list.push({ age: '14岁', 正常裸眼最低值: 5.0, 正常裸眼最高值: 5.0, 裸眼视力OD: null, 裸眼视力OS: null});
      list.push({ age: '15岁', 正常裸眼最低值: 5.0, 正常裸眼最高值: 5.0, 裸眼视力OD: null, 裸眼视力OS: null});
      list.push({ age: '16岁', 正常裸眼最低值: 5.0, 正常裸眼最高值: 5.0, 裸眼视力OD: null, 裸眼视力OS: null});
      list.push({ age: '17岁', 正常裸眼最低值: 5.0, 正常裸眼最高值: 5.0, 裸眼视力OD: null, 裸眼视力OS: null});
      list.push({ age: '18岁', 正常裸眼最低值: 5.0, 正常裸眼最高值: 5.0, 裸眼视力OD: null, 裸眼视力OS: null});
      list.push({ age: '19岁', 正常裸眼最低值: 5.0, 正常裸眼最高值: 5.0, 裸眼视力OD: null, 裸眼视力OS: null});
      list.push({ age: '20岁', 正常裸眼最低值: 5.0, 正常裸眼最高值: 5.0, 裸眼视力OD: null, 裸眼视力OS: null});
      if(age < 4){
        age = 4
      }
      if(age > 20){
        age = 20
      }
      age = ''+age+'岁';
      for (let i = 0; i < list.length; i++) {
        if(list[i].age == age){
          list[i].裸眼视力OD = od
          list[i].裸眼视力OS = os
        }
      }
      this.shiLiQuXianData.rows = list;
    },
    handleYanZhouFaYuQuXianData(age,od,os){
      var list = [];
      list.push({ age: '4岁',  眼轴标准均长: 18.7, 眼轴上限均值: 20.8, 眼轴年增长均值: 0.5, 眼轴OD: null, 眼轴OS: null});
      list.push({ age: '5岁',  眼轴标准均长: 19.2, 眼轴上限均值: 21.1, 眼轴年增长均值: 0.4, 眼轴OD: null, 眼轴OS: null});
      list.push({ age: '6岁',  眼轴标准均长: 19.6, 眼轴上限均值: 21.3, 眼轴年增长均值: 0.4, 眼轴OD: null, 眼轴OS: null});
      list.push({ age: '7岁',  眼轴标准均长: 20, 眼轴上限均值: 21.5, 眼轴年增长均值: 0.4, 眼轴OD: null, 眼轴OS: null});
      list.push({ age: '8岁',  眼轴标准均长: 20.3, 眼轴上限均值: 21.7, 眼轴年增长均值: 0.4, 眼轴OD: null, 眼轴OS: null});
      list.push({ age: '9岁',  眼轴标准均长: 20.7, 眼轴上限均值: 22, 眼轴年增长均值: 0.4, 眼轴OD: null, 眼轴OS: null});
      list.push({ age: '10岁', 眼轴标准均长: 21.1, 眼轴上限均值: 22.2, 眼轴年增长均值: 0.4, 眼轴OD: null, 眼轴OS: null});
      list.push({ age: '11岁', 眼轴标准均长: 21.6, 眼轴上限均值: 22.4, 眼轴年增长均值: 0.4, 眼轴OD: null, 眼轴OS: null});
      list.push({ age: '12岁', 眼轴标准均长: 22, 眼轴上限均值: 22.6, 眼轴年增长均值: 0.4, 眼轴OD: null, 眼轴OS: null});
      list.push({ age: '13岁', 眼轴标准均长: 22.4, 眼轴上限均值: 22.9, 眼轴年增长均值: 0.3, 眼轴OD: null, 眼轴OS: null});
      list.push({ age: '14岁', 眼轴标准均长: 22.7, 眼轴上限均值: 23.2, 眼轴年增长均值: 0.3, 眼轴OD: null, 眼轴OS: null});
      list.push({ age: '15岁', 眼轴标准均长: 23, 眼轴上限均值: 23.6, 眼轴年增长均值: 0.3, 眼轴OD: null, 眼轴OS: null});
      list.push({ age: '16岁', 眼轴标准均长: 23.3, 眼轴上限均值: 23.9, 眼轴年增长均值: 0.3, 眼轴OD: null, 眼轴OS: null});
      list.push({ age: '17岁', 眼轴标准均长: 23.5, 眼轴上限均值: 24.1, 眼轴年增长均值: 0.2, 眼轴OD: null, 眼轴OS: null});
      list.push({ age: '18岁', 眼轴标准均长: 23.7, 眼轴上限均值: 24.3, 眼轴年增长均值: 0.2, 眼轴OD: null, 眼轴OS: null});
      list.push({ age: '19岁', 眼轴标准均长: 23.8, 眼轴上限均值: 24.5, 眼轴年增长均值: 0.1, 眼轴OD: null, 眼轴OS: null});
      list.push({ age: '20岁', 眼轴标准均长: 24, 眼轴上限均值: 24.7, 眼轴年增长均值: 0, 眼轴OD: null, 眼轴OS: null});
      if(age < 4){
        age = 4
      }
      if(age > 20){
        age = 20
      }
      age = ''+age+'岁';
      for (let i = 0; i < list.length; i++) {
        if(list[i].age == age){
          list[i].眼轴OD = od
          list[i].眼轴OS = os
        }
      }
      this.YanZhouFaYuQuXianData.rows = list;
    },
    handleYanQuGuangFaYuQuXianData(age,od,os){
      var list = [];
      list.push({ age: '4岁',  生理性远视储备: 2.20, 等效球镜OD: null, 等效球镜OS: null});
      list.push({ age: '5岁',  生理性远视储备: 2.10, 等效球镜OD: null, 等效球镜OS: null});
      list.push({ age: '6岁',  生理性远视储备: 1.75, 等效球镜OD: null, 等效球镜OS: null});
      list.push({ age: '7岁',  生理性远视储备: 2.00, 等效球镜OD: null, 等效球镜OS: null});
      list.push({ age: '8岁',  生理性远视储备: 1.50, 等效球镜OD: null, 等效球镜OS: null});
      list.push({ age: '9岁',  生理性远视储备: 1.25, 等效球镜OD: null, 等效球镜OS: null});
      list.push({ age: '10岁', 生理性远视储备: 1.00, 等效球镜OD: null, 等效球镜OS: null});
      list.push({ age: '11岁', 生理性远视储备: 0.75, 等效球镜OD: null, 等效球镜OS: null});
      list.push({ age: '12岁', 生理性远视储备: 0.50, 等效球镜OD: null, 等效球镜OS: null});
      list.push({ age: '13岁', 生理性远视储备: 0, 等效球镜OD: null, 等效球镜OS: null});
      list.push({ age: '14岁', 生理性远视储备: 0, 等效球镜OD: null, 等效球镜OS: null});
      list.push({ age: '15岁', 生理性远视储备: 0, 等效球镜OD: null, 等效球镜OS: null});
      list.push({ age: '16岁', 生理性远视储备: 0, 等效球镜OD: null, 等效球镜OS: null});
      list.push({ age: '17岁', 生理性远视储备: 0, 等效球镜OD: null, 等效球镜OS: null});
      list.push({ age: '18岁', 生理性远视储备: 0, 等效球镜OD: null, 等效球镜OS: null});
      list.push({ age: '19岁', 生理性远视储备: 0, 等效球镜OD: null, 等效球镜OS: null});
      list.push({ age: '20岁', 生理性远视储备: 0, 等效球镜OD: null, 等效球镜OS: null});
      if(age < 4){
        age = 4
      }
      if(age > 20){
        age = 20
      }
      age = ''+age+'岁';
      for (let i = 0; i < list.length; i++) {
        if(list[i].age == age){
          list[i].等效球镜OD = od
          list[i].等效球镜OS = os
        }
      }
      this.YanQuGuangFaYuQuXianData.rows = list;
    },
    apiAddErp7ShiGuangYanJianKangQuXian: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      data = { ...data, ...that.myForm }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddErp7ShiGuangYanJianKangQuXian, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.myForm = Vue.prototype.CloneObj(that.myFormBack)
            that.$emit('triggerFunc', '')
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiEditErp7ShiGuangYanJianKangQuXian: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      data = { ...data, ...that.myForm }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditErp7ShiGuangYanJianKangQuXian, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
  },
};
</script>

<style>
 input{
    border: none;
    outline:medium;
    text-align:center;
    overflow: hidden;
    height: 100%;
    width: 95%;
  }
  .addbutton{
    position: fixed;
    top: 50vh;
    right: 60px;
  }
</style>
